function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M2.553 8.301L4.007 7.28c.38-.184.814-.218 1.217-.095l4.712 1.43a.377.377 0 0 1-.134.737l-2.964-.188a.29.29 0 0 0-.038.578l2.97.188h.06a.955.955 0 0 0 .278-1.87L5.396 6.632a2.261 2.261 0 0 0-1.667.139l-.038.023-1.425 1.004L.96 8.11a.289.289 0 1 0 .129.563l1.36-.326a.286.286 0 0 0 .104-.046z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M15.809 8.135a1.105 1.105 0 0 0-1.347-.552l-3 1.033a.287.287 0 0 0-.18.368.29.29 0 0 0 .367.18l3.002-1.034a.524.524 0 0 1 .42.955l-5.461 2.95a1.247 1.247 0 0 1-1.048.064c-4.942-1.937-5.094-1.933-5.187-1.935a.307.307 0 0 0-.115.026l-1.348.606a.289.289 0 1 0 .237.527l1.258-.563c.342.104 1.783.642 4.944 1.88a1.81 1.81 0 0 0 1.533-.094l5.463-2.952a1.1 1.1 0 0 0 .462-1.46zM6.062 5.991a.287.287 0 0 0 .237-.327 3.487 3.487 0 1 1 6.245 1.486.29.29 0 0 0 .232.462.286.286 0 0 0 .231-.117 4.02 4.02 0 0 0 .787-2.413 4.06 4.06 0 1 0-8.065.677.289.289 0 0 0 .333.232z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.742 6.913a.266.266 0 0 0 .268-.267v-.248c.19-.043.366-.135.51-.267a.743.743 0 0 0 .246-.548c0-.668-.454-.869-.942-.98-.488-.11-.477-.3-.49-.392a.367.367 0 0 1 .106-.233.256.256 0 0 1 .216-.07c.466.03.512.282.528.357a.268.268 0 1 0 .526-.096.936.936 0 0 0-.7-.746v-.294a.268.268 0 1 0-.536 0v.255a.767.767 0 0 0-.4.205.896.896 0 0 0-.267.653c.017.31.187.714.891.882.53.127.53.268.53.464a.21.21 0 0 1-.078.163.567.567 0 0 1-.35.145c-.128 0-.544-.062-.544-.49a.268.268 0 1 0-.536 0 .97.97 0 0 0 .754.98v.274a.266.266 0 0 0 .268.253z"
}));

var SvgSalesSvg = function SvgSalesSvg(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSalesSvg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/salesSvg.43c509da.svg";
export { ForwardRef as ReactComponent };